import { SubmitButton } from "@ameelio/ui";
import { useLazyQuery } from "@apollo/client/react";
import { Stack } from "@mui/material";
import { endOfQuarter, startOfQuarter } from "date-fns";
import { useState } from "react";
import { ContentSkeleton } from "../lib/closet";
import { DateInputBase } from "../lib/DateInput";
import Screen from "../lib/Screen";
import CallRatingsCharts from "./reports/CallRatingsCharts.tsx";
import { GetCallRatingsReportDocument } from "./reports/GetCallRatingsReport.generated.ts";

export default function CallRatingsReportScreen() {
  const [startDate, setStartDate] = useState<Date>(startOfQuarter(new Date()));
  const [endDate, setEndDate] = useState<Date>(endOfQuarter(new Date()));

  const [fetchCallRatingsReport, { data, error, loading }] = useLazyQuery(
    GetCallRatingsReportDocument,
    {
      fetchPolicy: "cache-first", // in the unlikely event someone searches the same date range
    }
  );

  if (error) throw error;

  return (
    <Screen title="Call ratings" maxWidth="md">
      <Stack spacing={2}>
        <Stack spacing={2} direction="row">
          <DateInputBase
            label="Start"
            value={new Date(startDate)}
            onChange={(val) => {
              if (val) setStartDate(val);
            }}
          />
          <DateInputBase
            label="End"
            value={new Date(endDate)}
            onChange={(val) => {
              if (val) setEndDate(val);
            }}
          />
          <SubmitButton
            submitting={loading}
            onClick={() => {
              fetchCallRatingsReport({
                variables: {
                  startDate: startDate.toISOString().split("T")[0],
                  endDate: endDate.toISOString().split("T")[0],
                },
              });
            }}
          >
            Go
          </SubmitButton>
        </Stack>
        <Stack spacing={2}>
          {loading && <ContentSkeleton />}
          {data && <CallRatingsCharts data={data.reports.callRatings} />}
        </Stack>
      </Stack>
    </Screen>
  );
}
